import { render, staticRenderFns } from "./text-list-item.vue?vue&type=template&id=43ddf5c5&scoped=true&"
import script from "./text-list-item.vue?vue&type=script&lang=js&"
export * from "./text-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ddf5c5",
  null
  
)

export default component.exports